const ProjectData = [
    {
        id : "1",
        name: "Fitness Mobile App (front end)",
        caption: "A fitness Mobile Application to help you along the way of your fitness journey.", 
        imageSource: "https://placehold.co/600x400",
        language: 'JavaScript / React Native',
        cardColor: 'yellow'
    },
    {
        id : "2",
        name: "Job Scraper",
        caption: "A web scraper made using the Ruby language.", 
        imageSource: "https://placehold.co/600x400",
        language: 'Ruby',
        cardColor: 'purple',
    },
    {
        id: '3',
        name: 'Portfolio Mania',
        caption: 'A website for anyone to host their own personal portfolio site.',
        imageSource: 'https://placehold.co/600x400',
        language: 'Ruby On Rails',
        cardColor: 'maroon',
    },
    {
        id: '4',
        name: 'Poke Info',
        caption: 'A mobile application for looking up pokemon data.',
        imageSource: 'https://placehold.co/600x400',
        language: 'React Native',
        cardColor: 'light-blue',
    },
    {
        id: '5',
        name: 'Fitness Mobile API (backend)',
        caption: 'A backend API created with Ruby that handles all CRUD operations for the Mobile Application..',
        imageSource: 'https://placehold.co/600x400',
        language: 'Ruby',
        cardColor: 'maroon',
    },
    {
        id: '6',
        name: 'LuxAura',
        caption: 'A website designed to display and convey the LuxAura company and services to prospective clients.',
        imageSource: 'https://placehold.co/600x400',
        language: 'Ruby on Rails',
        cardColor: 'maroon',
    }
]

export default ProjectData;